import { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Container,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  VStack,
  Spinner,
  Alert,
  AlertIcon,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";

import { API_BASE } from "./config";

function StackingLeaderboard() {
  const [stackingData, setStackingData] = useState<any[]>([]);
  const [leaderboardData, setLeaderboardData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchStackingData = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${API_BASE}/api/admin/staking/history`);
      setStackingData(res?.data?.data?.stakings || []);
    } catch (err: any) {
      setError(err?.response?.data?.message || "Error loading stacking data");
    } finally {
      setLoading(false);
    }
  };

  const fetchLeaderboardData = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(
        `${API_BASE}/api/admin/staking/leaderboard?page=1&limit=100`
      );
      setLeaderboardData(res?.data?.data || []);
    } catch (err: any) {
      setError(
        err?.response?.data?.message || "Error loading leaderboard data"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaderboardData();
    fetchStackingData();
  }, []);

  return (
    <Container maxW="container.xl" py={8}>
      <VStack spacing={8} align="stretch">
        <Heading as="h1" size="xl" textAlign="center">
          Stacking & Leaderboard
        </Heading>
        <Tabs isFitted variant="enclosed">
          <TabList mb="1em">
            <Tab>Stacking</Tab>
            <Tab>Leaderboard</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <Box overflowX="auto">
                {loading ? (
                  <Box textAlign="center" py={10}>
                    <Spinner />
                  </Box>
                ) : error ? (
                  <Alert status="error">
                    <AlertIcon />
                    {error}
                  </Alert>
                ) : (
                  <Table variant="simple">
                    <Thead>
                      <Tr>
                        <Th>Index</Th>
                        <Th>Address</Th>
                        <Th>Amount</Th>
                        <Th>Time</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {stackingData?.map((item: any, idx) => (
                        <Tr key={item?.address + idx}>
                          <Td>{idx + 1}</Td>
                          <Td>
                            {item?.address?.slice(0, 6)}...
                            {item?.address?.slice(-3)}
                          </Td>
                          <Td>{(+item?.amount)?.toFixed(2)}</Td>
                          <Td>
                            {item?.createdAt
                              ? new Date(item.createdAt).toLocaleString()
                              : ""}
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                )}
              </Box>
            </TabPanel>
            <TabPanel>
              <Box overflowX="auto">
                {loading ? (
                  <Box textAlign="center" py={10}>
                    <Spinner />
                  </Box>
                ) : error ? (
                  <Alert status="error">
                    <AlertIcon />
                    {error}
                  </Alert>
                ) : (
                  <Table variant="simple">
                    <Thead>
                      <Tr>
                        <Th>Rank</Th>
                        <Th>Wallet</Th>
                        <Th>Total XP</Th>
                        <Th>Level</Th>
                        <Th>Daily XP</Th>
                        <Th>Total Staked</Th>
                        <Th>Referrals</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {leaderboardData?.map((row: any, idx) => (
                        <Tr key={row?.wallet + idx}>
                          <Td>{idx + 1}</Td>
                          <Td>
                            {row?.address?.slice(0, 6)}...
                            {row?.address?.slice(-3)}
                          </Td>
                          <Td>{row?.totalXP?.toFixed(3)}</Td>
                          <Td>{row?.level ?? 0}</Td>
                          <Td>{row?.dailyXP?.toFixed(5)}</Td>
                          <Td>{row?.totalStaked?.toFixed(5)}</Td>
                          <Td>{row?.referralCount ?? 0}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                )}
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </VStack>
    </Container>
  );
}

export default StackingLeaderboard;
